<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

html,body,#app {
  height: 100%;
  width: 100%;
  margin: 0px;
  padding: 0px;
}

/* css计算屏幕高度 内容超出滚动 */
.drawer_body{
  height: calc(90vh);
  overflow-y:auto;
}

.drawer_body_100{
  height: calc(92vh);
  overflow-y:auto !important;
}

.main_body{
  height: calc(88vh);
  overflow-y:auto;
}

/* 固定分页右下角 */
.page_bottom{
  /* position: absolute; */
  position: fixed;
  bottom: 0;
  right: 30px;
  z-index: 2000;
  background-color: #ffffff;
}

</style>



// WEBPACK FOOTER //
// src/App.vue